/**
     * Scroll to Cart
     */
 if ($('#salesBanner').length) {
    let salesBannerHeight = Math.floor($('#salesBanner').height());

    if ($('#salesBanner').hasClass('isSticky')) {

        $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top - salesBannerHeight
            }, 1000);
        });
    } else {
        $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top
            }, 1000);
        });
    }
} else {
    $('.btn:not(.cta)').on('click', function (event) {
        $('html, body').animate({
            scrollTop: $("#orderNow").offset().top
        }, 1000);
    });
}